import React from "react";

// Duotone brand-green icons (founder pick "C3 duotone") — the
// custom replacements for Apple emojis on the Tip Me and Request Playlist
// checkouts. One soft green fill + one 1.8px stroke, 24-box, rounded caps.
// Never add an Apple emoji to these surfaces again — extend this set instead.

const FILL = "rgba(36, 201, 97, 0.22)";
const GREEN = "#24c961";

type IconProps = { size?: number };
export type GreenIcon = React.FC<IconProps>;

const Svg: React.FC<IconProps & { children: React.ReactNode }> = ({ size = 26, children }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    {children}
  </svg>
);

export const SparkleIcon: GreenIcon = (p) => (
  <Svg {...p}>
    <path d="M12 2 14.2 9.8 22 12 14.2 14.2 12 22 9.8 14.2 2 12 9.8 9.8Z" fill={FILL} stroke={GREEN} strokeWidth="1.8" strokeLinejoin="round" />
  </Svg>
);

export const SmileIcon: GreenIcon = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" fill={FILL} stroke={GREEN} strokeWidth="1.8" />
    <circle cx="8.6" cy="10" r="0.7" fill={GREEN} />
    <circle cx="15.4" cy="10" r="0.7" fill={GREEN} />
    <path d="M8 14.2c1 1.4 2.4 2.1 4 2.1s3-.7 4-2.1" stroke={GREEN} strokeWidth="1.8" strokeLinecap="round" />
  </Svg>
);

export const HeartIcon: GreenIcon = (p) => (
  <Svg {...p}>
    <path d="M12 20.3 4.9 13a4.7 4.7 0 0 1 6.7-6.7l.4.5.4-.5A4.7 4.7 0 0 1 19.1 13Z" fill={FILL} stroke={GREEN} strokeWidth="1.8" strokeLinejoin="round" />
  </Svg>
);

export const StarIcon: GreenIcon = (p) => (
  <Svg {...p}>
    <path d="m12 3.6 2.5 5.1 5.6.8-4 3.9.9 5.6-5-2.6-5 2.6.9-5.6-4-3.9 5.6-.8Z" fill={FILL} stroke={GREEN} strokeWidth="1.8" strokeLinejoin="round" />
  </Svg>
);

export const FlameIcon: GreenIcon = (p) => (
  <Svg {...p}>
    <path d="M12 21c-3.9 0-6.5-2.5-6.5-6 0-2.6 1.6-4.4 2.9-5.9C9.5 7.9 10.5 6.5 10.5 4c2.6 1.2 4 3 4.2 5.2.6-.5 1-1.2 1.2-2.2 1.6 1.7 2.6 3.9 2.6 6 0 3.5-2.6 6-6.5 6Z" fill={FILL} stroke={GREEN} strokeWidth="1.8" strokeLinejoin="round" />
  </Svg>
);

export const CrownIcon: GreenIcon = (p) => (
  <Svg {...p}>
    <path d="m3.5 8 3.6 3 4.9-5.5L16.9 11l3.6-3v9.5H3.5Z" fill={FILL} stroke={GREEN} strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M3.5 20.5h17" stroke={GREEN} strokeWidth="1.8" strokeLinecap="round" />
  </Svg>
);

export const BanknoteIcon: GreenIcon = (p) => (
  <Svg {...p}>
    <rect x="2.5" y="6.5" width="19" height="11.5" rx="2" fill={FILL} stroke={GREEN} strokeWidth="1.8" />
    <circle cx="12" cy="12.2" r="2.6" stroke={GREEN} strokeWidth="1.8" />
  </Svg>
);
